<template>
  <NavDrawer v-model:drawer="drawer" :rail="rail" />

  <v-main class="default-layout" :class="smAndDown ? 'x-is-smAndDown' : 'x-is-mdAndUp'">
    <AppHeader @toggle-drawer="toggleDrawer" />
    <v-container fluid class="pa-2 mb-2">
      <router-view />
    </v-container>
    <AppFooter />
  </v-main>
</template>

<script setup>
import { ref, watch } from 'vue';
import AppHeader from '../components/app/AppHeader.vue';
import AppFooter from '../components/app/AppFooter.vue';
import NavDrawer from '../components/app/NavDrawer.vue';
import { useDisplay } from 'vuetify';

const { smAndDown, mdAndUp } = useDisplay();

const drawer = ref(mdAndUp.value);
const rail = ref(!mdAndUp.value);

function toggleDrawer() {
  if (mdAndUp.value) {
    // On desktop: toggle rail mode only
    rail.value = !rail.value;
    drawer.value = true;
  } else {
    // On mobile: toggle open/close drawer
    drawer.value = !drawer.value;
    rail.value = false;
  }
}

watch(mdAndUp, isLargeScreen => {
  drawer.value = isLargeScreen ? true : false;
  rail.value = isLargeScreen ? true : false;
});
</script>

<style lang="scss">
@use '@/styles/main.scss';
</style>
